import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';
import Public from './views/Public.vue';
import UsersGroups from './views/secure/UsersGroups.vue';
import UsersGroup from './views/secure/UsersGroup.vue';
import Terminals from './views/secure/Terminals.vue';
import Terminal from './views/secure/Terminal.vue';
import ControlAccessCards from './views/secure/ControlAccessCards.vue';
import ControlAccessCard from './views/secure/ControlAccessCard.vue';
import HistoricalAccessControl from './views/secure/HistoricalAccessControl.vue';
import HistoricalOperation from './views/secure/HistoricalOperation.vue';
import Disconnected from './views/Disconnected.vue';
import About from './views/secure/About.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: {
        name: 'login' // poner home si no se quiere ir al login
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        public: true
      }
    },
    {
      path: '/disconnected',
      name: 'disconnected',
      component: Disconnected,
      meta: {
        public: true
      }
    },
    {
      path: '/home',
      name: 'home',
      component: Terminals,
      meta: {
        public: false
      },
      beforeEnter: (to, from, next) => {
        if ((JSON.parse(localStorage.vuex).user.role === 0) || (JSON.parse(localStorage.vuex).user.role === 1)) {
          next('/terminals');
        } else {
          next('/historicalaccesscontrol');
        }
      }
    },
    {
      path: '/usersGroups/:idUser',
      name: 'usersGroup',
      component: UsersGroup,
      meta: {
        public: false
      }
    },
    {
      path: '/usersGroups',
      name: 'usersGroups',
      component: UsersGroups,
      meta: {
        public: false
      }
    },
    {
      path: '/terminals',
      name: 'terminals',
      component: Terminals,
      meta: {
        public: false
      }
    },
    {
      path: '/newTerminal',
      name: 'newTerminal',
      component: Terminal,
      meta: {
        public: false
      }
    },
    {
      path: '/terminal/:idTerminal',
      name: 'terminal',
      component: Terminal,
      meta: {
        public: false
      }
    },
    {
      path: '/controlAccessCards',
      name: 'controlAccessCards',
      component: ControlAccessCards,
      meta: {
        public: false
      }
    },
    {
      path: '/newControlAccessCard',
      name: 'newControlAccessCard',
      component: ControlAccessCard,
      meta: {
        public: false
      }
    },
    {
      path: '/controlAccessCard/:idControlAccessCard',
      name: 'controlAccessCard',
      component: ControlAccessCard,
      meta: {
        public: false
      }
    },
    {
      path: '/historicalaccesscontrol',
      name: 'historicalaccesscontrol',
      component: HistoricalAccessControl,
      meta: {
        public: false
      }
    },
    {
      path: '/historicaloperation',
      name: 'historicaloperation',
      component: HistoricalOperation,
      meta: {
        public: false
      }
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta: {
        public: false
      }
    },
    { path: '*', component: Public }
  ]
});

router.afterEach((to, from) => {
  Vue.nextTick(() => {
      document.title = window._env_.VUE_APP_TITLE || "OdinS - WiCloudS";
  });
});

export default router;
